import { CodeEspece } from '../../declaration/models/enums/code-espece.enum';

export class EstimationStock {
    static jsonMap = {
        espece: { key: 'espece', optional: true },
        idGroupeVarietal: { key: 'idGroupeVarietal' },
        groupeVarietal: { key: 'groupeVarietal' },
        stock: { key: 'stock', optional: true }
    };

    public espece: string;
    public idGroupeVarietal: number;
    public groupeVarietal: string;
    public stock: number;

    sorting(): string {
        return ''.concat(this.espece === CodeEspece.POMME ? '0' : this.espece === CodeEspece.POIRE ? '1' : '2', this.groupeVarietal.toUpperCase());
    }
}
